import { forwardRef, useImperativeHandle } from 'react';

import {
  AnimatedCameraControlsHookOptions,
  useAnimatedCameraControls,
} from './useAnimatedCameraControls.js';

export interface AnimatedCameraControlsProps extends AnimatedCameraControlsHookOptions {
  loop?: boolean;
}
/**
 * This camera allows animation keyframes to be set and played back.
 */
export const AnimatedCameraControls: React.FC<AnimatedCameraControlsProps> = forwardRef(
  (props, forwardedRef) => {
    const controls = useAnimatedCameraControls(props);

    useImperativeHandle(forwardedRef, () => controls, [controls]);

    return <primitive dispose={null} object={controls} {...props} />;
  }
);
